import { atom } from 'jotai';

export const countAtom = atom<number>(0);